module.exports = __webpack_public_path__ + "img/Marca13.d9a046c0.jpg";